module.exports = __webpack_public_path__ + "img/filter.28850f14.png";